module.exports = __webpack_public_path__ + "static/media/dg1.4554b63d.jpg";